import { NotificationsModule } from "@/store/modules/notification.module";
import { ProjectModule } from "@/store/modules/project.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
const requestTrackingMachine = Machine({
    id: "requestTracking",
    context: {},
    initial: "idle",
    states: {
        idle: {
            always: [
                {
                    target: "notificationLoaded",
                },
            ],
        },
        notificationLoaded: {
            on: {
                LINK_SUBPROJECT_WITH_PARENTPROJECT: { target: "gettingParentProjectsForLinking" },
                REJECT_SUBPROJECT_LINKING: { target: "rejectSubProjectLinking" },
                MARK_AS_READ: { target: "markAsRead" },
            },
        },
        gettingParentProjectsForLinking: {
            invoke: {
                id: "gettingParentProjectsForLinking",
                src: (context, event) => {
                    return ProjectModule.GetAllParentProjectForLinking(event.projectId);
                },
                onDone: { target: "linkSubProjectWithParentProject" },
                onError: { target: "serviceUnavailable" },
            },
        },
        linkSubProjectWithParentProject: {
            on: {
                LINKING_SUBPROJECT_WITH_PARENTPROJECT: { target: "linkingSubProjectWithParentProject" },
                CLOSE_MODAL: { target: "notificationLoaded" },
            },
        },
        linkingSubProjectWithParentProject: {
            invoke: {
                id: "gettingParentProjectsForLinking",
                src: (context, event) => ProjectModule.LinkSubprojectToProject(event.payLoad),
                onDone: { target: "notificationLoaded", actions: "showSuccessMessage" },
                onError: { target: "serviceUnavailable" },
            },
        },
        rejectSubProjectLinking: {
            tags: "showDeleteUI",
            on: {
                REJECTING_SUBPROJECT_LINKING: { target: "rejectingSubProjectLinking" },
                CLOSE_MODAL: { target: "notificationLoaded" },
            },
        },
        rejectingSubProjectLinking: {
            tags: "showDeleteUI",
            invoke: {
                id: "rejectingSubProjectLinking",
                src: (context, event) => NotificationsModule.rejectSubProjectLinkingNotification(event.notificationId),
                onDone: { target: "notificationLoaded" },
                onError: { target: "serviceUnavailable" },
            },
        },
        markAsRead: {
            invoke: {
                id: "markAsRead",
                src: (context, event) => NotificationsModule.UpdateIsSeen(event.notificationId),
                onDone: { target: "notificationLoaded" },
                onError: { target: "serviceUnavailable" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: () => {
            toaster.ShowSuccess("These Projects have been linked successfully.");
        },
    },
    guards: {},
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 2000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default requestTrackingMachine;
